// État vide d'un écran : dit pourquoi il n'y a encore rien, ce qu'Ekera fera des pièces, et propose le geste suivant.
import { typo } from '../domaine/typo';
import { lienVers, type Page } from '../routeur';

export function EtatVide({
  titre,
  texte,
  page = 'depot',
  action = 'Déposer des pièces',
  idTitre,
}: {
  titre: string;
  /** Un paragraphe par entrée : ce qui manque, pourquoi, et ce qu'Ekera fera des pièces. */
  texte: string[];
  /** Écran où mène le bouton (par défaut le dépôt des documents). */
  page?: Page;
  action?: string;
  idTitre: string;
}) {
  return (
    <section className="panneau etat-vide" aria-labelledby={idTitre} data-testid="etat-vide">
      <h2 id={idTitre}>{typo(titre)}</h2>
      <div className="pile">
        {texte.map((t, i) => (
          <p key={i}>{typo(t)}</p>
        ))}
      </div>
      <p>
        <a className="btn principal" href={lienVers(page)}>
          {typo(action)}
        </a>{' '}
        <a href={lienVers('aide')}>Lire l’aide</a>
      </p>
    </section>
  );
}
